import { Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  hasRole: (resource: string) => boolean;

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.oktaAuth) {
      return this.oktaAuth.session.get().then((session) => {
        if (session.status !== 'ACTIVE') {
          this.oktaAuth.signOut();
          return false;
        }
      });
    }
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.oktaAuth) {
      return this.oktaAuth.session.get().then((session) => {
        if (session.status !== 'ACTIVE') {
          this.oktaAuth.signOut();
          return false;
        }
      });
    }
  }
}
